import script from "./DateInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=ts"

import "./DateInput.vue?vue&type=style&index=0&id=233868b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233868b8"]])

export default __exports__